<script setup lang="ts">
/** The cover card: kid-facing title, description and image. The admin's catalogue title stays in the header. */
import { AppText } from '@shared/ui/typography'
import { AppInput } from '@shared/ui/inputs'

import { useAssignmentCoverDetails } from '../../../model/assignments/assignment-cover-details.hook'
import AssignmentCoverUploader from './AssignmentCoverUploader.vue'

defineOptions({
  name: 'AssignmentCoverDetails',
})

const {
  refDefinitionTitle,
  refDefinitionDescription,
  refTitlePlaceholder,
} = useAssignmentCoverDetails()
</script>

<template>
  <div class="assignment-cover-details">
    <AppText name="body1-medium">
      Cover
    </AppText>

    <div class="assignment-cover-details__body">
      <div class="assignment-cover-details__fields">
        <AppInput
          v-model="refDefinitionTitle"
          label="Title"
          :placeholder="refTitlePlaceholder"
        />
        <AppInput
          v-model="refDefinitionDescription"
          label="Description"
          placeholder="One line under the title"
        />
      </div>

      <AssignmentCoverUploader class="assignment-cover-details__image" />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./AssignmentCoverDetails.scss" />
